import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { EdgePoolsPayload } from '~src/settings/general-settings/components/sections/bridge/types/EdgePoolsPayload';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetEdgePoolsParams {
  siteId: string;
}

export interface IGetEdgePoolsResult extends IResult {
  success?: EdgePoolsPayload;
  error?: {
    errorCode: string;
  };
  bridgeSettingsVersion: string;
}

export class GetEdgePoolsRequest extends Request<IGetEdgePoolsParams, IGetEdgePoolsResult> {
  constructor(params: IGetEdgePoolsParams) {
    super('getEdgePools', params);
  }
}
